import axios from 'axios'
// import * as mock from './api.mock'
import { appConfig, debounce, loadMoreCount } from '@/config'
import { blockInfo } from '@/store'

export const HTTP_REST = axios.create({
  baseURL: appConfig.rest,
  headers: {
    // 'x-requested-with': window.location.origin,
    // 'x-requested-with': 'https://platincoin.com',
    Accept: 'application/json, text/plain, */*',
  },
})

const errorPromise = errors =>
  Promise.resolve({
    data: {
      state: 'error',
      data: errors || { _common: ['internal_server_error'] },
    },
  })

const wrapRequest = request => {
  return request
    .then(response => {
      if (response.data.state !== 'success' || !response.data.data) {
        return errorPromise(response?.data?.errors)
      }
      return response
    })
    .catch(error => {
      return errorPromise(error.response?.data?.errors)
    })
}

const storeDebounce = {}
const wrapDebounce = (request, key) => {
  Object.keys(storeDebounce).forEach(i => {
    if (+new Date() - storeDebounce[i]?.ts > debounce) storeDebounce[i] = undefined
  })
  if (!storeDebounce[key] || +new Date() - storeDebounce[key].ts > debounce)
    storeDebounce[key] = { ts: +new Date(), promise: request() }
  return storeDebounce[key].promise
}

const txSort = (a, b) => {
  if (a.name !== a.address) return 1
  if (b.name !== b.address) return -1
  return a.locktime > b.locktime ? 1 : -1
}

const updateTx = tx => {
  const moneybox = blockInfo.moneybox || tx?.minting?.moneybox
  /** unique */
  if (tx.inputs) {
    tx.inputs = [...new Map(tx.inputs.map(i => [i.address, i])).values()]
    // tx.inputs = tx.inputs.map(i => (i === moneybox ? 'PLC Minting' : i))
  }
  if (Array.isArray(tx.inputs)) {
    tx.inputs = tx.inputs
      .map(i => ({
        ...i,
        name: i.address === moneybox ? 'PLC Minting' : i.address,
      }))
      .sort(txSort)
  } else {
    tx.inputs = []
  }
  if (Array.isArray(tx.outputs)) {
    tx.outputs = tx.outputs
      .map(i => ({
        ...i,
        name: i.address === moneybox ? 'PLC Minting' : i.address,
      }))
      .sort(txSort)
  } else {
    tx.outputs = []
  }
}

/** */
export const getIdentify = id => {
  return wrapDebounce(
    () => wrapRequest(HTTP_REST.get('v2/public/identify', { params: { id } })),
    `identify/${id}`
    // TODO:
  ).then(response => {
    if (response.data.state === 'error') return { data: { state: 'success', data: { type: '' } } }
    return response
  })
}

/** */
export const getBlockInfo = () => {
  return wrapDebounce(
    () => wrapRequest(HTTP_REST.get('v2/public/info/getblockchaininfo')),
    'block/info'
  ).then(response => {
    if (response.data.state === 'success') {
      blockInfo.moneybox = response.data.data.moneybox
    }
    return response
  })
}

/** */
export const getBlock = (id, cache) => {
  if (id < 0) return errorPromise()
  return wrapDebounce(
    () => wrapRequest(HTTP_REST.get('v2/public/block', { params: { id, cache } })),
    `block/${id}`
  ).then(response => {
    if (response.data.state === 'success') {
      const block = response.data.data
      block.tx = block.tx.sort((a, b) => (a.txid === b.txid ? 0 : a.txid > b.txid ? 1 : -1))
      block.tx.forEach(tx => updateTx(tx))
    }
    return response
  })
}

/** */
export const getTx = id => {
  return wrapDebounce(
    () => wrapRequest(HTTP_REST.get('v2/public/tx', { params: { id } })),
    `tx/${id}`
  ).then(response => {
    if (response.data.state === 'success') {
      updateTx(response.data.data)
    }
    return response
  })
}

/** */
export const getAddress = (id, page = 0, size = loadMoreCount) => {
  return wrapDebounce(
    () => wrapRequest(HTTP_REST.get('v2/public/address', { params: { id, page, size } })),
    `address/${id}/${page}/${size}`
  ).then(response => {
    if (response.data.state === 'success') {
      response.data.data.tx.forEach(tx => updateTx(tx))
    }
    return response
  })
}

/** */
export const getBlockList = async (count = 6) => {
  return wrapDebounce(
    () => wrapRequest(HTTP_REST.get(`v2/public/block/last?limit=${count}`)),
    'block/last'
  )
}

/** */
export const getTxLast = async (count = 10) => {
  return wrapDebounce(
    () => wrapRequest(HTTP_REST.get(`v2/public/tx/last?limit=${count}`)),
    'tx/last'
  )
}
